import type { PublicationCode } from '@/scopes/common/domain/types'
import type { FiltersInQuickSearch } from '@/scopes/search/quick-search/domain/types'

// TODO check if we can unify this domain policy with the one in `scopes/search/search/domain/policies/publicationCodes.ts`
const filterSelections: Record<string, Partial<FiltersInQuickSearch>> = {
  SZ: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }] },
  FS: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }] },
  BZ: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }] },
  WG: { Duration: ['8-10'], Participants: [{ adults: 4, children: [], babies: [] }], TransportType: 'SelfDrive' },
  KZ: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }] },
  KW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  QZ: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }] },
  QW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  FW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  FZ: { Duration: ['8-9'], Participants: [{ adults: 2, children: [], babies: [] }] },
  FH: { Duration: ['8-999'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  BW: { Duration: ['8-10'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
}

export function getDefaultFilterSelection(publicationCode: PublicationCode): Partial<FiltersInQuickSearch> {
  return filterSelections[publicationCode] ?? {}
}
